import React from 'react';

import { AvatarSC } from './avatar.styled';
import svgIconDoctorMark from '@common/assets/svg/icon-doctor_mark.svg';
import svgIconAvatar from '@common/assets/svg/icon-avatar.svg';

type TAvatarProps = {
  imgUrl?: string;
  isDoctor?: boolean;
  notificationsCount?: number;
  onClick?: () => null;
  className?: string;
};

const Avatar: React.FC<TAvatarProps> = ({ isDoctor, imgUrl, onClick, className }: TAvatarProps) => (
  <AvatarSC onClick={onClick} className={className ? className : ''}>
    <img className="profile-image" src={imgUrl ? imgUrl : svgIconAvatar} alt="profile_image" />
    {/*<NotificationCount count={notificationsCount} className="avatar-notifications" />*/}
    {isDoctor && <img className="avatar-check" src={svgIconDoctorMark} alt="" />}
  </AvatarSC>
);

Avatar.defaultProps = {
  imgUrl: undefined,
  isDoctor: true,
  notificationsCount: 0,
  onClick: () => null,
  className: '',
};

export default Avatar;
